import Earnings from "./Earnings";

export default Earnings;